import type { ReactNode } from "react";
import { useBusyIndicator } from "../../contexts/BusyIndicatorContext";

export type BusyIndicatorMode = "overlay" | "section";

export interface BusyIndicatorProps {
  children?: ReactNode;
  scope?: string;
  message?: string;
  mode?: BusyIndicatorMode;
  isOpen?: boolean;
}

export function BusyIndicator(props: BusyIndicatorProps) {
  const { isBusy, getBusyMessage } = useBusyIndicator();
  const isOpen = props.isOpen ?? isBusy(props.scope);
  const message =
    props.message ?? getBusyMessage(props.scope) ?? "Please wait...";
  const mode = props.mode ?? (props.children ? "section" : "overlay");

  return {
    children: props.children,
    isOpen,
    message,
    mode,
  };
}
